import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { CompanyDetailView } from "@/views/company-detail/company-detail.view";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { CompanyView } from "./company.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function CompanyRoutes() {
  const ability = useAbility();
  const companyUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const companyDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Company");

  return (
    <Switch>
      <Route path={"/"} component={CompanyView} />
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={companyUpdateUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={companyDetailUuidRegex} component={CompanyDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
